import { Button } from '@mevaser/ui'
import { Download } from 'lucide-react'
import { apiBaseUrl } from '../lib/api.js'

/**
 * Downloads the whole customer list as CSV (t1247) — the "back up first"
 * step offered before a merge or a bulk delete. Always the full list, never
 * the current filter: the point is a restore point for everything.
 */
export function CustomerBackupButton() {
  return (
    <Button
      variant="secondary"
      size="sm"
      onClick={() => window.location.assign(`${apiBaseUrl}/customers/export.csv`)}
    >
      <Download /> Download a backup first
    </Button>
  )
}
